<div *ngIf="regActions && regActions?.length > 0">
    <div
        ngbDropdown
        class="d-inline-block m-3"
    >
        <button
            class="btn"
            id="actionDropdown"
            ngbDropdownToggle
        >Actions</button>
        <div
            ngbDropdownMenu
            aria-labelledby="actionDropdown"
        >
            <button
                ngbDropdownItem
                *ngFor="let action of regActions"
                class="dropdown-item"
            >
                <a
                    routerLink={{action.url}}
                    [innerHTML]="action.text | safe: 'html'"
                ></a>
            </button>
        </div>
    </div>
</div>
